/*jshint esversion: 6 */
import React, { Component } from 'react';
import '../css/Utils.css';
import '../css/SideMenu.css';
import '../css/tooltip.css';
import SmallLogo from '../Templates/SmallLogo.js';

class SideMenu extends Component {
    constructor(props){
        super(props);
        this.state = {
          menuItems: [],
        };
        this.displaySideMenu = this.displaySideMenu.bind(this);
    }
   
    displaySideMenu(){
        const pathname = window.location.pathname.toLowerCase();

        let sidePanel = [];
        let pagetitles = this.props.pagetitles.slice();
        let subPageObjects = this.props.subPageObjects.slice();
        let pageObject = this.props.pageObject;
        let pageObjTitle = this.props.pageObject.pagetitle;
        let subLinks = [];
        subPageObjects.map((subPageObject, i) => {
          let linkObjArr= pagetitles.filter(pgto => pgto.parent === pageObjTitle);
          if(linkObjArr){
            if(linkObjArr.length){
              subLinks = linkObjArr[0].subpages;
            }
          }
          let subLinkObj = subLinks.filter(sl => sl.title === subPageObject.pagetitle);
          let sublink = subLinkObj? (subLinkObj[0]? subLinkObj[0].link : '') : '';
          //console.log('displaySideMenu linkObjArr', subLinkObj);
          //
          //
          const hashval = window.location.hash.substr(0);
          console.log('displaySideMenu hashval', hashval);
          console.log('displaySideMenu sublink', sublink);
          let subMenuDelimiter = (hashval && sublink.indexOf(hashval) > -1)? ("sideMenu_delimiter_visible current_submenu") : "";
          //
          sidePanel.push(
            <li  className={"sideMenu_li_class " + subMenuDelimiter} key={i}>
                <a href = {sublink}>
                    {subPageObject.pagetitle}
                </a>
            </li>
          );
        });
        return sidePanel;
      }
    
    render() {
      const sideMenu = this.displaySideMenu();
      return (
        <div className="side_menu_container">
          <ul className="sideMenu_ul_class">
          {sideMenu}
          </ul>
          <div className="clear_div"></div> 
        </div>
      );
    }
  }
  
  export default SideMenu;


// WEBPACK FOOTER //
// ./src/Components/SideMenu.js